/* eslint-disable react/react-in-jsx-scope */
import { useAuth } from "@/auth/hooks/useAuth";
import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

const AuthenticationRequired: FC<{ children: ReactNode; redirect: string }> = ({
  children,
  redirect,
}) => {
  const { user, logout, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  if (
    (!isAuthenticated ||
      !user?.isVerified ||
      !user?.roles?.includes("ROLE_FUNDER")) &&
    !loading
  ) {
    logout();
    navigate(`/login${redirect ? `?redirect=${redirect}` : ""}`);
    return <></>;
  }

  return children;
};

export default AuthenticationRequired;
